import { IGameCell } from "@/common/interface";
import SpecialTitle from "@/components/common/SpecialTitle";
import classnames from "classnames";
import React, { useState, useRef, useEffect } from "react";
import Card from "../Card";
import { useInViewport } from "ahooks";
import { sendClkLog } from "@/common/selfMonitor";
import { ICategorys } from "@/common/interface";
import { comMonitor, replaceUrlTemplate } from "@/utils/com";

import "./index.scss";
interface IProps {
  data: IGameCell[];
  title: React.ReactNode;
  className?: string;
  position?: string;
}

const SpecialItem = ({ data = {} as IGameCell, position = "" as string }) => {
  const [startTime, setStartTime] = useState(0);
  const onMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setStartTime(Date.now());
  };

  const onMouseUp = (e: React.MouseEvent) => {
    if (Array.isArray(data.clktk) && data.clktk.length) {
      const now = Date.now();
      data.clktk.forEach((url) => {
        const realUrl = replaceUrlTemplate(url, e, startTime, now);
        comMonitor(realUrl);
      });
    }
  };
  return (
    <li
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      className="special__item"
    >
      <Card data={data} position={position} />
    </li>
  );
};

const Special = ({ data, title, className, position }: IProps) => {
  const list = data.map((item, index) => (
    <SpecialItem data={item} key={index} position={position} />
  ));
  const mergeClassName = classnames("special", className);
  const nodeRef = useRef<HTMLOListElement>(null);
  const [lock, setLock] = useState(false);
  const [inViewport, ratio] = useInViewport(nodeRef, {
    threshold: [0.1, 0.5, 1],
  });

  useEffect(() => {
    if (inViewport && !lock && ratio && ratio >= 0.1 && data[0].name) {
      const monitorIds = data
        .reduce<string>((prev, current) => {
          return (
            prev +
            "|" +
            `${current.soft_id}$${current.name}$${
              current.category && current.category.length
                ? ICategorys[current.category]
                : ICategorys[1]
            }`
          );
        }, "")
        .slice(1);

      const params = {
        cid: position, //事件名称组名
        // c : "下载", //事件名称
        // from: (category && category.length) ? ICategorys[category] : '',
        title: monitorIds,
      };
      sendClkLog(params, "track");
      setLock(true);

      const urlItems = data.filter((item) => {
        return item.imptk;
      });
      urlItems.forEach((item) => {
        item.imptk.forEach((img: string) => {
          comMonitor(img);
        });
      });
    }
  }, [inViewport, data, lock, ratio, position]);
  return (
    <div className={mergeClassName} data-bk={title}>
      <SpecialTitle>{title}</SpecialTitle>
      <ul ref={nodeRef} className="special__list">
        {list}
      </ul>
    </div>
  );
};

export default Special;
